module.exports = __webpack_public_path__ + "img/intro_no.d5a0f45a.svg";